import React from 'react';
export const AppointmentSection = () => {
  return <section className="py-20 bg-[#f2f2ed] w-full" data-id="element-47">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-48">
        <div className="mb-16" data-id="element-49">
          <h6 className="text-sm uppercase tracking-wider text-[#3a4a56] font-medium mb-6" data-id="element-50">
            Appointments
          </h6>
          <h2 className="text-4xl md:text-5xl font-normal text-[#3a4a56] leading-tight mb-10" data-id="element-51">
            Book an Online Appointment
          </h2>
          <p className="text-lg text-[#3a4a56] max-w-3xl" data-id="element-52">
            Schedule a consultation with our luxury real estate experts
          </p>
        </div>
        <div className="p-8 border border-[#3a4a56]" data-id="element-53">
          {/* Placeholder for an appointment scheduling embed */}
          <div className="flex flex-col items-center justify-center h-96 border-2 border-dashed border-[#3a4a56] rounded-lg" data-id="element-54">
            <p className="text-[#3a4a56] text-lg" data-id="element-55">
              Online Appointment Scheduling System
            </p>
            <p className="text-[#3a4a56] text-sm mt-2" data-id="element-56">
              (Embed your scheduling system here)
            </p>
          </div>
        </div>
      </div>
    </section>;
};